const translations = {
  // ─── NAVBAR ───
  nav: {
    products: { en: 'Products', fr: 'Produits' },
    truckCampers: { en: '2026 Truck Campers', fr: 'Campeurs portés 2026' },
    truckCampersDesc: { en: 'NEW — Factory-built. 100% wood-free.', fr: 'NOUVEAU — Fabriqués en usine. 100 % sans bois.' },
    keiTruck: { en: 'Kei Truck Box', fr: 'Caisson Kei Truck' },
    keiTruckDesc: { en: 'Ultra-light insulated composite cargo box', fr: 'Caisson cargo composite ultra-léger isolé' },
    flatKits: { en: 'Expedition Kits', fr: 'Kits expédition' },
    flatKitsDesc: { en: 'Ready-to-assemble composite box & shell kits', fr: 'Kits de caissons et coques composites prêts à assembler' },
    truckBodies: { en: 'Truck Bodies', fr: 'Carrosseries de camion' },
    truckBodiesDesc: { en: 'Commercial composite truck body solutions', fr: 'Solutions de carrosserie composite commerciales' },
    customProjects: { en: 'Custom Projects', fr: 'Projets sur mesure' },
    customProjectsDesc: { en: 'Bespoke expedition enclosures & containers', fr: 'Habitacles et conteneurs d\'expédition sur mesure' },
    whyTC: { en: 'Why TOTAL COMPOSITES', fr: 'Pourquoi TOTAL COMPOSITES' },
    expeditions: { en: 'Expeditions', fr: 'Expéditions' },
    builderResources: { en: 'Builder Resources', fr: 'Ressources constructeurs' },
    partners: { en: 'Partners', fr: 'Partenaires' },
    gallery: { en: 'Gallery', fr: 'Galerie' },
    media: { en: 'Media', fr: 'Médias' },
    articles: { en: 'Blog', fr: 'Blogue' },
    about: { en: 'About', fr: 'À propos' },
    contact: { en: 'Contact', fr: 'Contact' },
    newsMedia: { en: 'News & Media', fr: 'Nouvelles & Médias' },
    events: { en: 'Events', fr: 'Événements' },
    expeditionsDesc: { en: 'Arctic & global expedition stories', fr: 'Récits d\'expéditions arctiques et mondiales' },
    articlesDesc: { en: 'Blog posts & company updates', fr: 'Articles de blogue et nouvelles de l\'entreprise' },
    mediaDesc: { en: 'Press releases & media coverage', fr: 'Communiqués de presse et couverture médiatique' },
    galleryDesc: { en: 'Photo gallery of builds & expeditions', fr: 'Galerie photo de constructions et expéditions' },
    logIn: { en: 'LOG IN', fr: 'CONNEXION' },
    logOut: { en: 'LOG OUT', fr: 'DÉCONNEXION' },
    adminPanel: { en: 'ADMIN PANEL', fr: 'PANNEAU ADMIN' },
    portal: { en: 'PARTNER PORTAL', fr: 'PORTAIL PARTENAIRE' },
    onlineShop: { en: 'Online Shop', fr: 'Boutique en ligne' },
    new2026: { en: 'NEW 2026', fr: 'NOUVEAU 2026' },
  },

  // ─── FOOTER ───
  footer: {
    tagline: { en: "North America's leading supplier of premium composite panels and truck camper systems. Victoria, BC, Canada.", fr: "Le principal fournisseur nord-américain de panneaux composites haut de gamme et de systèmes de campeur porté. Victoria, C.-B., Canada." },
    productsTitle: { en: 'Products', fr: 'Produits' },
    companyTitle: { en: 'Company', fr: 'Entreprise' },
    contactTitle: { en: 'Contact', fr: 'Contact' },
    aboutUs: { en: 'About Us', fr: 'À propos de nous' },
    onlineShop: { en: 'Online Shop →', fr: 'Boutique en ligne →' },
    copyright: { en: 'TOTAL COMPOSITES Technologies Ltd. All rights reserved.', fr: 'TOTAL COMPOSITES Technologies Ltd. Tous droits réservés.' },
    engineered: { en: 'Engineered in Victoria, BC, Canada', fr: 'Conçu à Victoria, C.-B., Canada' },
  },

  // ─── HOME PAGE ───
  home: {
    heroTagline: { en: 'TOTAL COMPOSITES', fr: 'TOTAL COMPOSITES' },
    heroSub: { en: 'ENGINEERED FOR EXPEDITION', fr: 'CONÇU POUR L\'EXPÉDITION' },
    scrollDown: { en: 'Scroll to explore', fr: 'Défiler pour explorer' },
    aboutTitle: { en: 'ABOUT TOTAL COMPOSITES', fr: 'À PROPOS DE TOTAL COMPOSITES' },
    aboutHeading: { en: 'Engineering the future of expedition vehicles.', fr: 'Concevoir l\'avenir des véhicules d\'expédition.' },
    aboutText1: { en: 'Based in Victoria, BC, TOTAL COMPOSITES Technologies designs and manufactures advanced composite panels and complete camper systems for the world\'s most demanding environments.', fr: 'Basée à Victoria, C.-B., TOTAL COMPOSITES Technologies conçoit et fabrique des panneaux composites avancés et des systèmes de campeur porté complets pour les environnements les plus exigeants au monde.' },
    aboutText2: { en: 'Our panels have been tested from the Sahara Desert to Antarctica — used by overlanders, expeditions, and commercial fleets across 30+ countries.', fr: 'Nos panneaux ont été testés du désert du Sahara à l\'Antarctique — utilisés par des overlanders, des expéditions et des flottes commerciales dans plus de 30 pays.' },
    learnMore: { en: 'Learn More', fr: 'En savoir plus' },
    statsTitle: { en: 'TOTAL COMPOSITES BY THE NUMBERS', fr: 'TOTAL COMPOSITES EN CHIFFRES' },
    productsTitle: { en: 'OUR PRODUCTS', fr: 'NOS PRODUITS' },
    productsHeading: { en: 'Composite solutions for every build.', fr: 'Des solutions composites pour chaque construction.' },
    viewDetails: { en: 'View Details', fr: 'Voir les détails' },
    viewAll: { en: 'View All Products', fr: 'Voir tous les produits' },
    partnersTitle: { en: 'TRUSTED PARTNERS', fr: 'PARTENAIRES DE CONFIANCE' },
    partnersHeading: { en: 'Used by world-class builders and expedition teams.', fr: 'Utilisés par des constructeurs et des équipes d\'expédition de classe mondiale.' },
    ctaTitle: { en: 'READY TO START YOUR BUILD?', fr: 'PRÊT À COMMENCER VOTRE PROJET ?' },
    ctaHeading: { en: 'Let\'s build something extraordinary.', fr: 'Construisons quelque chose d\'extraordinaire.' },
    ctaText: { en: 'Whether you\'re planning a custom expedition build, a commercial fleet upgrade, or exploring our factory-built 2026 campers — our team is ready to help.', fr: 'Que vous planifiiez un projet d\'expédition sur mesure, une mise à niveau de flotte commerciale ou que vous découvriez nos campeurs portés 2026 fabriqués en usine — notre équipe est prête à vous aider.' },
    ctaContact: { en: 'Contact Our Team', fr: 'Contacter notre équipe' },
    ctaOrder: { en: 'Configure a Camper', fr: 'Configurer un campeur porté' },
    startingAt: { en: 'Starting at', fr: 'À partir de' },
  },

  // ─── PRODUCTS PAGE ───
  products: {
    pageTitle: { en: 'Products', fr: 'Produits' },
    pageSubtitle: { en: 'Premium composite solutions for expedition, commercial, and custom builds.', fr: 'Solutions composites haut de gamme pour expéditions, usage commercial et projets sur mesure.' },
    truckCampersTitle: { en: '2026 Truck Campers', fr: 'Campeurs portés 2026' },
    truckCampersSubtitle: { en: 'Factory-Built Expedition Campers — 100% Wood-Free', fr: 'Campeurs portés d\'expédition fabriqués en usine — 100 % sans bois' },
    keiTruckTitle: { en: 'Kei Truck Box', fr: 'Caisson Kei Truck' },
    flatKitsTitle: { en: 'Expedition Kits', fr: 'Kits expédition' },
    truckBodiesTitle: { en: 'Truck Bodies', fr: 'Carrosseries' },
    customTitle: { en: 'Custom Projects', fr: 'Projets sur mesure' },
    configureOrder: { en: 'Configure & Order', fr: 'Configurer et commander' },
    requestQuote: { en: 'Request a Quote', fr: 'Demander un devis' },
    viewSpecs: { en: 'View Specifications', fr: 'Voir les spécifications' },
    startingAt: { en: 'Starting at', fr: 'À partir de' },
    contactForPricing: { en: 'Contact for Pricing', fr: 'Contactez-nous pour les prix' },
    features: { en: 'Features', fr: 'Caractéristiques' },
    specifications: { en: 'Specifications', fr: 'Spécifications' },
    weight: { en: 'Weight', fr: 'Poids' },
    dimensions: { en: 'Dimensions', fr: 'Dimensions' },
    insulation: { en: 'Insulation', fr: 'Isolation' },
    construction: { en: 'Construction', fr: 'Construction' },
  },

  // ─── GALLERY ───
  gallery: {
    title: { en: 'Gallery', fr: 'Galerie' },
    subtitle: { en: 'Expedition builds, custom projects, and adventure photography from around the world.', fr: 'Constructions d\'expédition, projets sur mesure et photographies d\'aventure du monde entier.' },
    loadMore: { en: 'Load More Photos', fr: 'Charger plus de photos' },
    showing: { en: 'Showing', fr: 'Affichage de' },
    of: { en: 'of', fr: 'sur' },
    photos: { en: 'photos', fr: 'photos' },
  },

  // ─── CONTACT ───
  contact: {
    title: { en: 'Contact Us', fr: 'Contactez-nous' },
    subtitle: { en: 'Get in touch with our team for quotes, technical questions, or partnership inquiries.', fr: 'Contactez notre équipe pour des devis, des questions techniques ou des demandes de partenariat.' },
    formTitle: { en: 'Send us a message', fr: 'Envoyez-nous un message' },
    firstName: { en: 'First Name', fr: 'Prénom' },
    lastName: { en: 'Last Name', fr: 'Nom' },
    email: { en: 'Email Address', fr: 'Adresse courriel' },
    phone: { en: 'Phone Number', fr: 'Numéro de téléphone' },
    subject: { en: 'Subject', fr: 'Sujet' },
    message: { en: 'Your Message', fr: 'Votre message' },
    send: { en: 'Send Message', fr: 'Envoyer le message' },
    sending: { en: 'Sending...', fr: 'Envoi en cours...' },
    success: { en: 'Message sent successfully!', fr: 'Message envoyé avec succès !' },
    error: { en: 'Failed to send message. Please try again.', fr: 'Échec de l\'envoi. Veuillez réessayer.' },
    infoTitle: { en: 'Contact Information', fr: 'Coordonnées' },
    visitUs: { en: 'Visit Us', fr: 'Visitez-nous' },
    callUs: { en: 'Call Us', fr: 'Appelez-nous' },
    emailUs: { en: 'Email Us', fr: 'Écrivez-nous' },
    businessHours: { en: 'Business Hours', fr: 'Heures d\'ouverture' },
    monFri: { en: 'Monday - Friday: 8:00 AM - 5:00 PM PST', fr: 'Lundi - Vendredi : 8 h - 17 h, heure du Pacifique' },
    subjectOptions: {
      general: { en: 'General Inquiry', fr: 'Demande générale' },
      quote: { en: 'Request a Quote', fr: 'Demander un devis' },
      technical: { en: 'Technical Question', fr: 'Question technique' },
      partnership: { en: 'Partnership Inquiry', fr: 'Demande de partenariat' },
      media: { en: 'Media / Press', fr: 'Médias / Presse' },
    },
  },

  // ─── ORDER FORMS ───
  order: {
    title: { en: 'Configure Your Camper', fr: 'Configurez votre campeur porté' },
    subtitle: { en: 'Select your model and options to request a quote.', fr: 'Sélectionnez votre modèle et vos options pour demander un devis.' },
    model: { en: 'Select Model', fr: 'Choisir le modèle' },
    name: { en: 'Full Name', fr: 'Nom complet' },
    email: { en: 'Email', fr: 'Courriel' },
    phone: { en: 'Phone', fr: 'Téléphone' },
    country: { en: 'Country', fr: 'Pays' },
    notes: { en: 'Additional Notes', fr: 'Notes supplémentaires' },
    submit: { en: 'Submit Order Request', fr: 'Soumettre la demande' },
    submitting: { en: 'Submitting...', fr: 'Envoi en cours...' },
    success: { en: 'Order request submitted successfully!', fr: 'Demande de commande soumise avec succès !' },
    error: { en: 'Failed to submit. Please try again.', fr: 'Échec de la soumission. Veuillez réessayer.' },
  },

  // ─── MEDIA PAGE ───
  media: {
    title: { en: 'Media & Press', fr: 'Médias et presse' },
    subtitle: { en: 'News, press releases, and media coverage about TOTAL COMPOSITES.', fr: 'Actualités, communiqués de presse et couverture médiatique de TOTAL COMPOSITES.' },
    pressKit: { en: 'Press Kit', fr: 'Dossier de presse' },
    downloadPressKit: { en: 'Download Press Kit', fr: 'Télécharger le dossier de presse' },
    mediaContact: { en: 'Media Contact', fr: 'Contact médias' },
    readMore: { en: 'Read More', fr: 'Lire la suite' },
    latestNews: { en: 'Latest News', fr: 'Dernières nouvelles' },
    pressReleases: { en: 'Press Releases', fr: 'Communiqués de presse' },
    inTheMedia: { en: 'In The Media', fr: 'Dans les médias' },
  },

  // ─── ABOUT PAGE ───
  about: {
    title: { en: 'About Us', fr: 'À propos de nous' },
    subtitle: { en: 'Learn about TOTAL COMPOSITES and our mission to engineer the future of expedition vehicles.', fr: 'Découvrez TOTAL COMPOSITES et notre mission de concevoir l\'avenir des véhicules d\'expédition.' },
    ourStory: { en: 'Our Story', fr: 'Notre histoire' },
    ourMission: { en: 'Our Mission', fr: 'Notre mission' },
    ourTeam: { en: 'Our Team', fr: 'Notre équipe' },
  },

  // ─── WHY TOTAL COMPOSITES ───
  why: {
    title: { en: 'Why TOTAL COMPOSITES', fr: 'Pourquoi TOTAL COMPOSITES' },
    subtitle: { en: 'The advantages of choosing composite panel technology for your expedition build.', fr: 'Les avantages de la technologie des panneaux composites pour votre projet d\'expédition.' },
  },

  // ─── CHAT WIDGET ───
  chat: {
    greeting: { en: 'Hi! I\'m DISCO, your Total Composites assistant. How can I help you today?', fr: 'Bonjour ! Je suis DISCO, votre assistant Total Composites. Comment puis-je vous aider aujourd\'hui ?' },
    placeholder: { en: 'Type your message...', fr: 'Tapez votre message...' },
    send: { en: 'Send', fr: 'Envoyer' },
    askName: { en: 'What\'s your name?', fr: 'Quel est votre nom ?' },
    askEmail: { en: 'What\'s your email?', fr: 'Quel est votre courriel ?' },
    chatWith: { en: 'Chat with DISCO', fr: 'Discuter avec DISCO' },
    poweredBy: { en: 'Powered by AI', fr: 'Propulsé par l\'IA' },
    thinking: { en: 'Thinking...', fr: 'Réflexion en cours...' },
    newConversation: { en: 'New Conversation', fr: 'Nouvelle conversation' },
  },

  // ─── FOOTER ─── (continued)
  footer2: {
    resourcesTitle: { en: 'Resources', fr: 'Ressources' },
  },

  // ─── ERROR MODAL ───
  errorModal: {
    title: { en: 'Form Validation Error', fr: 'Erreur de validation du formulaire' },
    subtitle: { en: 'Please correct the following errors before submitting:', fr: 'Veuillez corriger les erreurs suivantes avant de soumettre :' },
    gotIt: { en: 'Got It', fr: 'Compris' },
  },

  // ─── LOGIN MODAL ───
  login: {
    portalLabel: { en: 'Partner Portal & Admin Panel', fr: 'Portail partenaire et panneau admin' },
    heading: { en: 'Access Your Dashboard', fr: 'Accédez à votre tableau de bord' },
    description: { en: 'For authorized TOTAL COMPOSITES partners and administrators. Access technical resources, manage files, view customer inquiries, and oversee portal operations.', fr: 'Réservé aux partenaires et administrateurs autorisés de TOTAL COMPOSITES. Accédez aux ressources techniques, gérez les fichiers, consultez les demandes clients et supervisez les opérations du portail.' },
    username: { en: 'Username', fr: 'Nom d\'utilisateur' },
    usernamePlaceholder: { en: 'Your username', fr: 'Votre nom d\'utilisateur' },
    password: { en: 'Password', fr: 'Mot de passe' },
    passwordPlaceholder: { en: 'Your password', fr: 'Votre mot de passe' },
    signingIn: { en: 'Signing in…', fr: 'Connexion en cours…' },
    accessPortal: { en: 'Access Portal', fr: 'Accéder au portail' },
    needAccess: { en: 'Need access?', fr: 'Besoin d\'accès ?' },
    contactUs: { en: 'Contact us', fr: 'Contactez-nous' },
    forgotPassword: { en: 'Forgot password?', fr: 'Mot de passe oublié ?' },
    backToLogin: { en: 'Back to login', fr: 'Retour à la connexion' },
    passwordReset: { en: 'Password Reset', fr: 'Réinitialisation du mot de passe' },
    forgotHeading: { en: 'Forgot Password', fr: 'Mot de passe oublié' },
    forgotDescription: { en: 'Enter the email address associated with your portal account. A member of the TOTAL COMPOSITES team will reach out to reset your access.', fr: 'Entrez l\'adresse courriel associée à votre compte portail. Un membre de l\'équipe TOTAL COMPOSITES vous contactera pour réinitialiser votre accès.' },
    emailLabel: { en: 'Email Address', fr: 'Adresse courriel' },
    sending: { en: 'Sending…', fr: 'Envoi en cours…' },
    submitRequest: { en: 'Submit Request', fr: 'Soumettre la demande' },
    requestReceived: { en: 'Request Received', fr: 'Demande reçue' },
    checkInbox: { en: 'Check your inbox', fr: 'Vérifiez votre boîte de réception' },
    requestConfirm: { en: 'Your request has been received.', fr: 'Votre demande a été reçue.' },
    requestConfirmDesc: { en: 'A member of the TOTAL COMPOSITES team will review your request and reach out to', fr: 'Un membre de l\'équipe TOTAL COMPOSITES examinera votre demande et contactera' },
    requestConfirmSuffix: { en: 'to assist with your password reset.', fr: 'pour vous aider à réinitialiser votre mot de passe.' },
    invalidCredentials: { en: 'Invalid credentials. Please try again.', fr: 'Identifiants invalides. Veuillez réessayer.' },
  },

  // ─── NAVBAR POPUP ───
  navPopup: {
    eufSubtitle: { en: 'Your Overland Gear Destination', fr: 'Votre destination d\'équipement overland' },
    eufDescription: { en: 'Explore the best overland equipment, camper kits, accessories, and gear — curated for serious adventurers.', fr: 'Découvrez les meilleurs équipements overland, kits campeur, accessoires et matériel — sélectionnés pour les aventuriers sérieux.' },
  },

  // ─── VALIDATION ERRORS ───
  validation: {
    nameRequired: { en: 'Name field is required', fr: 'Le champ nom est obligatoire' },
    nameEmpty: { en: 'Name field cannot be empty', fr: 'Le champ nom ne peut pas être vide' },
    emailRequired: { en: 'Email address is required', fr: 'L\'adresse courriel est obligatoire' },
    emailInvalid: { en: 'Please enter a valid email address', fr: 'Veuillez entrer une adresse courriel valide' },
    emailInvalidDetail: { en: 'Please enter a valid email address (e.g., name@example.com)', fr: 'Veuillez entrer une adresse courriel valide (ex : nom@exemple.com)' },
    phoneRequired: { en: 'Phone number is required', fr: 'Le numéro de téléphone est obligatoire' },
    agreeTerms: { en: 'You must agree to the terms and conditions', fr: 'Vous devez accepter les conditions générales' },
    subjectRequired: { en: 'Please select a subject from the dropdown', fr: 'Veuillez sélectionner un sujet dans le menu déroulant' },
    messageEmpty: { en: 'Message field cannot be empty - please tell us about your inquiry', fr: 'Le champ message ne peut pas être vide — veuillez décrire votre demande' },
    messageMinLength: { en: 'Message must be at least 10 characters long', fr: 'Le message doit contenir au moins 10 caractères' },
    emailInvalidApi: { en: 'Email address is invalid or already in use', fr: 'L\'adresse courriel est invalide ou déjà utilisée' },
    spamDetected: { en: 'Submission flagged as spam. Please ensure all fields are filled correctly.', fr: 'Soumission signalée comme spam. Veuillez vous assurer que tous les champs sont correctement remplis.' },
    submissionFailed: { en: 'Form submission failed. Please check all required fields and try again.', fr: 'Échec de la soumission. Veuillez vérifier tous les champs obligatoires et réessayer.' },
    networkError: { en: 'Network error. Please check your internet connection and try again.', fr: 'Erreur réseau. Veuillez vérifier votre connexion internet et réessayer.' },
    serverUnreachable: { en: 'Unable to reach the server. Please check your connection.', fr: 'Impossible de joindre le serveur. Veuillez vérifier votre connexion.' },
    orderSubmitFailed: { en: 'Order submission failed. Please verify all fields and try again.', fr: 'Échec de la soumission de commande. Veuillez vérifier tous les champs et réessayer.' },
    emailInvalidOrder: { en: 'Email address is invalid', fr: 'L\'adresse courriel est invalide' },
    phoneInvalidOrder: { en: 'Phone number format is invalid', fr: 'Le format du numéro de téléphone est invalide' },
  },

  // ─── ORDER PAGE EXTRAS ───
  orderExtras: {
    addOnsTitle: { en: 'Add-Ons Options', fr: 'Options supplémentaires' },
    addOnsDesc: { en: "Select any add-ons you're interested in. A representative will contact you to confirm choices, models and sizes.", fr: 'Sélectionnez les options qui vous intéressent. Un représentant vous contactera pour confirmer les choix, modèles et tailles.' },
    windows: { en: 'Windows', fr: 'Fenêtres' },
    roofHatch: { en: 'Roof Hatch', fr: 'Trappe de toit' },
    waterBoiler: { en: 'Water Boiler', fr: 'Chauffe-eau' },
    waterFiltration: { en: 'Water Filtration System', fr: 'Système de filtration d\'eau' },
    dieselHeater: { en: 'Diesel Heater', fr: 'Chauffage diesel' },
    bedSlats: { en: 'Bed Slats', fr: 'Lattes de lit' },
    recoveryBoard: { en: 'Recovery Board', fr: 'Plaque de désensablement' },
    disclaimer: { en: 'Disclaimer', fr: 'Avis' },
    disclaimerText1: { en: 'All prices are listed in CAD and are subject to change without notice. A representative will contact you to review and confirm your order details, including available options and specifications, prior to production.', fr: 'Tous les prix sont en CAD et peuvent être modifiés sans préavis. Un représentant vous contactera pour examiner et confirmer les détails de votre commande, y compris les options disponibles et les spécifications, avant la production.' },
    disclaimerText2: { en: 'All deposits are non-refundable.', fr: 'Tous les dépôts sont non remboursables.' },
    disclaimerText3: { en: 'Pricing does not include applicable taxes or freight charges. Shipping costs will be calculated based on delivery to your nearest authorized dealer.', fr: 'Les prix n\'incluent pas les taxes applicables ni les frais de transport. Les frais d\'expédition seront calculés en fonction de la livraison chez votre concessionnaire autorisé le plus proche.' },
    disclaimerText4: { en: 'Submission of a pre-order deposit constitutes acknowledgment and acceptance of the Pre-Order Agreement, as well as our Terms of Use and Privacy Policy.', fr: 'La soumission d\'un dépôt de précommande constitue la reconnaissance et l\'acceptation du contrat de précommande, ainsi que de nos conditions d\'utilisation et politique de confidentialité.' },
    disclaimerText5: { en: 'By selecting "Submit," you confirm that you have read, understood, and agree to the above terms, and consent to being contacted by TOTAL COMPOSITES and Expedition Upfitter regarding your pre-order.', fr: 'En sélectionnant « Soumettre », vous confirmez avoir lu, compris et accepté les conditions ci-dessus, et consentez à être contacté par TOTAL COMPOSITES et Expedition Upfitter concernant votre précommande.' },
    agreeTerms: { en: 'I confirm that I have read and agree to the website terms and conditions', fr: 'Je confirme avoir lu et accepte les conditions générales du site' },
    basePrice: { en: 'Base Price', fr: 'Prix de base' },
    emptyShell: { en: 'Empty Shell', fr: 'Coque vide' },
    emptyShellDesc: { en: 'Dimensions fixed — no customization', fr: 'Dimensions fixes — aucune personnalisation' },
    vehicleInfo: { en: 'Vehicle Information', fr: 'Informations sur le véhicule' },
    year: { en: 'Year', fr: 'Année' },
    make: { en: 'Make', fr: 'Marque' },
    modelLabel: { en: 'Model', fr: 'Modèle' },
    bedType: { en: 'Bed Type', fr: 'Type de caisse' },
    selectBedType: { en: 'Select bed type', fr: 'Sélectionner le type' },
    cabType: { en: 'Cab Type', fr: 'Type de cabine' },
    selectCabType: { en: 'Select cab type', fr: 'Sélectionner le type' },
    yourInfo: { en: 'Your Information', fr: 'Vos informations' },
    deposit: { en: 'Deposit — Non Refundable', fr: 'Dépôt — Non remboursable' },
    balanceDue: { en: 'Balance due before production', fr: 'Solde dû avant la production' },
    orderTotal: { en: 'Order Total', fr: 'Total de la commande' },
    preOrderSubmitted: { en: 'Pre-order submitted!', fr: 'Pré-commande soumise !' },
  },

  // ─── COMMON ───
  common: {
    new: { en: 'NEW', fr: 'NOUVEAU' },
    comingSoon: { en: 'Coming Soon', fr: 'Bientôt disponible' },
    backToHome: { en: 'Back to Home', fr: 'Retour à l\'accueil' },
    viewAll: { en: 'View All', fr: 'Voir tout' },
    close: { en: 'Close', fr: 'Fermer' },
    cancel: { en: 'Cancel', fr: 'Annuler' },
    save: { en: 'Save', fr: 'Enregistrer' },
    edit: { en: 'Edit', fr: 'Modifier' },
    delete: { en: 'Delete', fr: 'Supprimer' },
    loading: { en: 'Loading...', fr: 'Chargement...' },
    required: { en: 'Required', fr: 'Obligatoire' },
  },

  // ─── BUILDER RESOURCES ───
  builder: {
    title: { en: 'Builder Resources', fr: 'Ressources constructeurs' },
    subtitle: { en: 'Technical guides, CAD files, and resources for builders.', fr: 'Guides techniques, fichiers CAO et ressources pour les constructeurs.' },
  },

  // ─── EXPEDITION ───
  expedition: {
    title: { en: 'Expeditions', fr: 'Expéditions' },
    subtitle: { en: 'TOTAL COMPOSITES products in the most extreme environments on Earth.', fr: 'Les produits TOTAL COMPOSITES dans les environnements les plus extrêmes de la planète.' },
  },

  // ─── PARTNERS ───
  partnerPage: {
    title: { en: 'Our Partners', fr: 'Nos partenaires' },
    subtitle: { en: 'Trusted by leading expedition builders and commercial fleets worldwide.', fr: 'Approuvé par les principaux constructeurs d\'expédition et flottes commerciales à travers le monde.' },
  },
};

export default translations;
